import * as React from 'react'

import type { NavigationLogoViewModel } from '../../view-models/NavigationLogoViewModel'
import Image from '../Image/Image'
import Link from '../Link/Link'

type Props = NavigationLogoViewModel & {
  className?: string
}
type State = {}

class NavigationLogo extends React.Component<Props, State> {
  static displayName = 'NavigationLogo'
  static defaultProps = {}

  render() {
    const { image, link, className } = this.props
    if (!image && !link) return null

    return (
      <div className={className ? className : ''}>
        {link ? (
          <Link {...link}>
            <Image {...image} contain />
          </Link>
        ) : (
          <Image {...image} />
        )}
      </div>
    )
  }
}

export default NavigationLogo